import React from "react";
import { useNavigate } from "react-router-dom";
import {
  LogHeaderContainer,
  LogHeaderLeftContainer,
  IconContainer,
} from "./LogHeader.styled";
import {  Icon, Typography } from "@ann/web-components";

const LogHeader = () => {
  const navigate = useNavigate();
  

  return (
    <>
      <LogHeaderContainer>
        <LogHeaderLeftContainer>
          <IconContainer onClick={() => navigate("/v2/workflows")}>
            <Icon name="arrowLeft" size="medium" />
          </IconContainer>
          <Typography category="title" size="medium" weight="bold">
            Workflows
          </Typography>
        </LogHeaderLeftContainer>
      </LogHeaderContainer>

    </>
  );
};

export default LogHeader;
